import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getMyTokens, MyTokensInfo } from 'services/conlicitacao_api_request';

const maskToken = (value: string): string => {
  if (value.length <= 4) return '••••';
  return `${'•'.repeat(value.length - 4)}${value.slice(-4)}`;
};

const MeusTokens: React.FC = () => {
  const history = useHistory();
  const [info, setInfo] = useState<MyTokensInfo | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [revealed, setRevealed] = useState<boolean>(false);
  const [copied, setCopied] = useState<boolean>(false);

  useEffect(() => {
    document.title = 'Meu token da API - ConLicitação';

    let active = true;
    getMyTokens()
      .then((data) => {
        if (active) setInfo(data);
      })
      .catch(() => {
        if (active) setInfo(null);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  const token = info ? info.api_token : null;

  const handleCopy = () => {
    if (!token || !navigator.clipboard || !navigator.clipboard.writeText) return;
    navigator.clipboard
      .writeText(token)
      .then(() => {
        setCopied(true);
        window.setTimeout(() => setCopied(false), 2000);
      })
      .catch(() => undefined);
  };

  return (
    <div className="page-container">
      <div className="container p-4 mt-5">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-8">
            <div className="card card-shadow p-3 p-md-4">
              <h4 className="font-weight-bold mb-3">Meu token da API</h4>

              {loading && <p className="text-muted mb-0">Carregando…</p>}

              {!loading && !token && (
                <div className="alert alert-info mb-0">
                  Você ainda não tem acesso à API liberado. Assim que a sua solicitação for
                  concluída, o token aparece aqui.
                </div>
              )}

              {!loading && token && (
                <>
                  <p className="font-weight-bold mb-1">Token de acesso</p>
                  <div className="d-flex align-items-center flex-wrap mb-2">
                    <code
                      className="mr-3 mb-2"
                      style={{ fontSize: '15px', wordBreak: 'break-all' }}
                    >
                      {revealed ? token : maskToken(token)}
                    </code>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary mr-2 mb-2"
                      onClick={() => setRevealed((value) => !value)}
                    >
                      {revealed ? 'Ocultar' : 'Revelar'}
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary mb-2"
                      onClick={handleCopy}
                    >
                      {copied ? 'Copiado!' : 'Copiar'}
                    </button>
                  </div>
                  <p className="text-muted small">
                    Use este token no header <code>X-Auth-Token</code> das chamadas à API, a partir
                    de um dos IPs cadastrados.
                  </p>

                  <p className="font-weight-bold mt-3 mb-1">IPs liberados</p>
                  {info && info.ips.length > 0 ? (
                    <ul className="list-group mb-0">
                      {info.ips.map((item) => (
                        <li key={item.ip} className="list-group-item py-2">
                          {item.ip}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-muted mb-0">Nenhum IP cadastrado ainda.</p>
                  )}
                </>
              )}

              <div className="mt-4">
                <button type="button" className="btn btn-link p-0" onClick={() => history.goBack()}>
                  ← Voltar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeusTokens;
